import { ModalVisibilityProps } from 'sb-modal'
import { useCallback, useEffect } from 'sb-hooks'
import { snowplow } from 'common/helpers'

import { openGiftOfferConfirmModal } from 'compositions/modals/cancelSubscription'


export type UseGiftOfferModalProps = GiftOfferModal.ModalProps & ModalVisibilityProps


const useGiftOfferModal = (props: UseGiftOfferModalProps): GiftOfferModal.ReturnType => {
  const { product, coupon, openNextModal, closeModal, onConfirm, onClose } = props

  const handleConfirm = useCallback(() => {
    closeModal()
    openGiftOfferConfirmModal({ coupon, onConfirm })
  }, [ closeModal, onConfirm ])

  const onContinue = useCallback(() => {
    closeModal()
    openNextModal()
  }, [ closeModal, openNextModal ])

  useEffect(() => {
    snowplow.track('UF offer popup', { offer: 'free product' })
  }, [])

  return {
    product,
    onContinue,
    onConfirm: handleConfirm,
    onClose,
  }
}


export default useGiftOfferModal
